export default "__VITE_ASSET__bd99f60a__"